/* ----------------------------------------------------------------------------------
import読み込み
---------------------------------------------------------------------------------- */
import {
  contentAdjustFunc,
  resetStyleFunc
} from './common/_common';
import {
  hoverFunc,
  telLinkFunc,
  uaHoverFunc,
  hoverOtherFunc
} from './common/_hoverFunc';
import {
  headerFunc
} from './common/_header';
import {
  resizeFuncCheck,
  resizeFunc
} from './common/_resizecheck';
import {
  heightLine,
  heightLineSetFunc,
  heightLineFunc
} from './common/_heightLine';
import {
  pageLinkAnimationFunc,
  externalPageLinkFunc
} from './common/_pageLinkAnimation';
import {
  idxFunc
} from './pages/_index';
import {
  calendarFunc
} from './pages/_calendar';
import {
  faqFunc
} from './pages/_outline';
import {
  eventViewFunc
} from './pages/_eventView';

/* ----------------------------------------------------------------------------------
通常実行
---------------------------------------------------------------------------------- */
idxFunc();
var setTimer, w, wResize;
setTimer = false;

/* ----------------------------------------------------------------------------------
window実行

---------------------------------------------------------------------------------- */
// ロード時
$(window).on('load', function () {
  heightLine();
  heightLineSetFunc();
  contentAdjustFunc();
  headerFunc();
  pageLinkAnimationFunc();
  calendarFunc();
  faqFunc();
  //外部リンクアンカー
  externalPageLinkFunc();
  //イベント詳細ページ
  eventViewFunc();
});

// リサイズ時
$(window).on('resize', function () {
  contentAdjustFunc();
  resetStyleFunc();
  heightLineSetFunc();
  //イベント詳細ページ

  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(function () {
    //リサイズ終了後の処理
    w = $(window).width();
    wResize = $(window).width();
    if (w != wResize) {
      eventViewFunc();
      w = $(window).width();
    }
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {

});
/* ----------------------------------------------------------------------------------
ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
---------------------------------------------------------------------------------- */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
  uaHoverFunc();
} else {
  // PC時の処理
  uaFlag = 3;
  hoverFunc();
  telLinkFunc();
  hoverOtherFunc();
}
/* ----------------------------------------------------------------------------------
IEだけの時
---------------------------------------------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {
  contentAdjustFunc();
  pageLinkAnimationFunc();
  calendarFunc();
  faqFunc();
}